import { inject, Pipe, PipeTransform } from '@angular/core';
import { EUserRole } from '@modules/iam/enum/user.role.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'userRole'
})
export class UserRolePipe implements PipeTransform {
    protected translate = inject(TranslateService);

    transform(role: EUserRole): any {
        const roleString = `MODULE_IAM.ROLES.${role}`.toUpperCase();
        return this.translate.instant(roleString);
    }
}
